import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GetBotResponse } from 'src/app/models/bot.interface';
import { MessageService } from 'primeng/api';
import { SlackBotService } from 'src/app/core/services/slack-bot.service';

@Component({
  selector: 'globot-slack-bot',
  templateUrl: './slack-bot.component.html',
  styleUrls: ['./slack-bot.component.scss'],
})
export class SlackBotComponent implements OnInit {
  @Input() bot?: GetBotResponse;
  slackBot: FormGroup;
  teamId!: string;
  checked: boolean = false;
  is_enabled: boolean = false;

  constructor(
    private fb: FormBuilder,
    private slackBotService: SlackBotService,
    private ms: MessageService
  ) {
    this.slackBot = this.fb.group({
      teamId: [{ value: '', disabled: false }, Validators.required],
      checked: [false],
    });
  }

  ngOnInit(): void {
    this.slackBotService.getBotSlack(this.bot!.id).subscribe({
      next: (response) => {
        this.teamId = response.team_id;
        this.is_enabled = response.is_enabled;
        this.slackBot.patchValue({
          teamId: this.teamId,
          checked: this.is_enabled,
        });
      },
      error: (err) => {
        console.error('Hubo un error al obtener el team_id:', err);
      },
    });
  }

  onSubmitTeamId() {
    let team_id = this.slackBot.get('teamId')!.value;

    this.slackBot.patchValue({ teamId: team_id });

    if (this.bot?.id) {
      if (this.teamId) {
        let team_id = this.slackBot.get('teamId')!.value;
        this.slackBotService.updateBotSlack(this.bot.id, undefined!, team_id).subscribe({
          next: (_response) => {
            this.ms.add({
              key: 'tst',
              severity: 'success',
              summary: 'Acción exitosa',
              detail: '¡ID del team actualizado!',
            });
          },
          error: (_err) => {
            this.ms.add({
              key: 'tst',
              severity: 'error',
              summary: 'Acción fallida',
              detail: 'ID ya asociado a otro chatbot. Ingrese un ID único y vuelva a intentarlo',
            });
          },
        });
      } else {
        this.slackBotService
          .postBotSlack(this.bot.id, team_id, this.is_enabled || false)
          .subscribe({
            next: (_response) => {
              this.ms.add({
                key: 'tst',
                severity: 'success',
                summary: 'Acción exitosa',
                detail: '¡Bot de Discord agregado con éxito!',
              });
            },
            error: (_err) => {
              this.ms.add({
                key: 'tst',
                severity: 'error',
                summary: 'Acción fallida',
                detail: 'ID ya asociado a otro chatbot. Ingrese un ID único y vuelva a intentarlo.',
              });
            },
          });
      }
    } else {
      this.ms.add({
        key: 'tst',
        severity: 'error',
        summary: 'Acción fallida',
        detail: 'El ID del servidor no es válido',
      });
    }
  }

  switchChanged(event: any) {
    this.checked = event.checked;

    this.slackBotService.updateBotSlack(this.bot!.id, this.checked).subscribe({
      next: (_response) => {
        this.is_enabled = this.checked;
        if (this.checked) {
          this.ms.add({
            key: 'tst',
            severity: 'success',
            summary: 'Acción exitosa',
            detail: '¡Discord Bot habilitado!',
          });
        } else {
          this.ms.add({
            key: 'tst',
            severity: 'success',
            summary: 'Acción exitosa',
            detail: '¡Discord Bot deshabilitado!',
          });
        }
      },
      error: (_err) => {
        this.ms.add({
          key: 'tst',
          severity: 'error',
          summary: 'Acción fallida',
          detail: 'Hubo un problema con el habilitado de tu Discord Bot.',
        });
      },
    });
  }
}
